import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['form'];

  connect() {
    console.log('save controller connected');
    this.setupSaveShortcut();
  }

  setupSaveShortcut() {
    window.addEventListener('keydown', (event) => {
      // Check if Command (metaKey) and 'S' (keyCode 83) are pressed
      if (event.metaKey && event.keyCode === 83) {
        event.preventDefault(); // Prevent the browser's save dialog
        this.submitForm();
      }
    });
  }

  submitForm() {
    this.formTarget.requestSubmit(); // This method submits the form
    console.log('Form submitted via Command+S');
  }
}
